import { Route, Routes, useLocation, type Location } from "react-router-dom";

import { LandingPage, NotFoundPage, WorkspaceHomePage } from "./pages";

import { AuthCompletePage } from "@/features/auth/AuthCompletePage";
import { AuthErrorPage } from "@/features/auth/AuthErrorPage";
import { RequireAuthentication } from "@/features/auth/RequireAuthentication";
import { SignInPage } from "@/features/auth/SignInPage";
import { AdminUsersPage } from "@/features/admin/AdminUsersPage";
import {
  WorkspaceIndex,
  WorkspaceRoute,
} from "@/features/workspaces/WorkspaceRoute";
import { AppLayout } from "@/shared/layouts/AppLayout";
import { PublicLayout } from "@/shared/layouts/PublicLayout";

type RouteState = { backgroundLocation?: Location };

export function AppRouter() {
  const location = useLocation();
  const backgroundLocation = (location.state as RouteState | null)
    ?.backgroundLocation;

  return (
    <>
      <Routes location={backgroundLocation ?? location}>
        <Route element={<PublicLayout />}>
          <Route index element={<LandingPage />} />
        </Route>
        <Route element={<SignInPage />} path="/signin" />
        <Route element={<AuthCompletePage />} path="/auth/complete" />
        <Route element={<PublicLayout />}>
          <Route element={<AuthErrorPage />} path="/auth/error" />
        </Route>
        <Route element={<RequireAuthentication />}>
          <Route element={<AppLayout />}>
            <Route element={<AdminUsersPage />} path="/admin" />
            <Route element={<WorkspaceIndex />} path="/app" />
            <Route element={<WorkspaceRoute />} path="/app/:tenantId">
              <Route index element={<WorkspaceHomePage />} />
            </Route>
          </Route>
        </Route>
        <Route element={<NotFoundPage />} path="*" />
      </Routes>
      {backgroundLocation && (
        <Routes>
          <Route element={<SignInPage modal />} path="/signin" />
        </Routes>
      )}
    </>
  );
}
